import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../../service/serviceURL';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as $ from 'jquery';
declare var $: any;

@Component({
    selector: 'app-retrieve-quote',
    templateUrl: './retrieve-quote.component.html',
    styleUrls: ['./retrieve-quote.component.css']
})
export class RetrieveQuoteComponent implements OnInit {
    retrieveProspects: any = [];
    listView: boolean = true;
    detailedView: boolean = false;
    detailedData: any = {};
    searchType: any = 'Mobile';
    loginUserDetails: any = {};
    loading: boolean;
    isQuoteMessage:boolean=false;
    isMobileMessage:boolean=false;
    isCorrectMobile:boolean=false;

private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private router: Router, private location: Location, private serviceURLService: serviceURLService) {

    }

    ngOnInit() {
        this.getRMId();

    }

    getRMId() {
        if (localStorage.getItem('role')) {
            this.loginUserDetails = JSON.parse(localStorage.getItem('role'));
        }

    }

    getRetrieveQuote(type, mobile) {

        if(type=='Mobile'){
        this.loading = true;
        this.serviceURLService.retrieveQuoteList(type, mobile, this.loginUserDetails.pamUserID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
            this.loading = false;
           if(successData.data){ 
               this.retrieveProspects = successData.data.prospects;
               this.isCorrectMobile=false;
               this.isQuoteMessage=false;
               this.isMobileMessage=false;
               if(!this.retrieveProspects.length){
                this.isMobileMessage=true;
               }
           }
           else{
            this.isMobileMessage=false;  
            this.isQuoteMessage=false;
            this.isCorrectMobile=true;
            this.retrieveProspects =[];
           }
            
        }, errorData => {
            this.loading = false;
        }
        )
    }
    if(type=='Quote Id'){
        this.loading = true;
        this.serviceURLService.retrieveQuote(mobile).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
            this.retrieveProspects = successData.data.prospects;
            this.loading = false;
            if(successData.data.isFound){
                this.isMobileMessage=false;  
                this.isCorrectMobile=false;
                this.isQuoteMessage=true;
            }
            else{
                this.isMobileMessage=false;  
                this.isCorrectMobile=false;
                this.isQuoteMessage=false;
            }
        }, errorData => {
            this.loading = false;
        }
        )
    }
    }

    sendSms() {
        this.loading = true;
        let data = {
            quoteId: this.detailedData.quoteId,
            requestType: 'sms',
            view: this.detailedData.view
        }
        this.serviceURLService.sendRetriveSms(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
            this.loading = false;
        }, errorData => {
            this.loading = false;
        }
        )
    }

    sendEmail() {
        this.loading = true;
        let data = {
            quoteId: this.detailedData.quoteId,
            requestType: 'mail',
            view: this.detailedData.view
        }
        this.serviceURLService.sendRetriveEmail(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
            this.loading = false;
            $('#confirmedSentMail').modal('show');
             setTimeout (() => {
                 $('#confirmedSentMail').modal('hide');
              }, 1400);
        }, errorData => {
            this.loading = false;
        }
        )
    }

    copyViewUrl(url) {
        if (url) {
            var textField = document.createElement('textarea');
            textField.innerText = url;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            textField.remove();   
            $('#confirmCopied').modal('show');
             setTimeout (() => {
                 $('#confirmCopied').modal('hide');
              }, 1400);
        }
    }
    closeDetails(){
        this.listView = true;
        this.detailedView = false;
    }
    
    showDetaildView(detail) {
        this.detailedData = detail;
        this.listView = false;
        this.detailedView = true;
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        }

        

}